import { BrowserStylsheet } from './BrowserStylesheet';
export class BrowserStylesheets {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get documentStyleSheets() {
        return Array.from(document.styleSheets);
    }
    nativeStylesheedByName(name) {
        return this.documentStyleSheets.find(s => s.href && s.href.includes(name));
    }
    stylesheets = new Map();
    stylesheetByName(name) {
        if (this.stylesheets.has(name)) {
            return this.stylesheets.get(name);
        }
        const s = new BrowserStylsheet(this, name);
        this.stylesheets.set(name, s);
        return s;
    }
}
